import React from "react";

const FormDetailsStatCard = ({ value, suffix = "", label }) => (
  <div className="bg-secondary rounded-xl p-6">
    <div className="flex flex-col">
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-bold text-gray-900">{value}</span>
        {suffix && <span className="text-gray-600">{suffix}</span>}
      </div>
      <div className="text-gray-500 text-sm">{label}</div>
    </div>
  </div>
);

export default FormDetailsStatCard;
